import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (hovered) => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[50],
  borderRadius: (p) => p.spacing(0.5),
  background: hovered
    ? (p) => p.palette.primary[50]
    : (p) => p.palette.common.white,
  padding: (p) => p.spacing(2, 1),
});

export const avatar: SxStyle = {
  width: (p) => p.spacing(3),
  height: (p) => p.spacing(3),
};

export const percent: SxStyle = {
  borderRadius: (p) => p.spacing(2),
  background: (p) => p.palette.grey[200],
  fontSize: (p) => p.typography.body5.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  color: (p) => p.palette.primary[900],
  padding: (p) => p.spacing(0, 0.5),
  mb: 0.5,
};
